import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MyWallet from 'components/pages/Statistics/StatisticsContent/Grids/components/MyWallet'
import NextClass from 'components/pages/Statistics/StatisticsContent/Grids/components/NextClass'
import Classes from 'components/pages/Statistics/StatisticsContent/Grids/components/Classes'
import MyProfileTutor from 'components/pages/Statistics/StatisticsContent/Grids/components/MyProfileTutor'
import TopTutors from 'components/pages/Statistics/StatisticsContent/Grids/components/TopTutors'
import TopCategories from 'components/pages/Statistics/StatisticsContent/Grids/components/TopCategories'
import News from 'components/pages/Statistics/StatisticsContent/Grids/components/News'
import StatisticCard from './StatisticCard'

import { getTutorStats } from 'routing/fetchingfunction/dashboard/dashboard.action'
import {
  selectTopCategories,
  selectTopTutors,
  selectTutorNextClass,
} from 'routing/fetchingfunction/dashboard/dashboard.reducer'

import { statisticBreakdowns, statisticIntervals } from 'constants'

const Statistic = () => {
  const dispatch = useDispatch()

  const topTutors = useSelector(selectTopTutors)
  const topCategories = useSelector(selectTopCategories)
  const nextClass = useSelector(selectTutorNextClass)

  const [tab, setTab] = useState('nft')
  const [interval, setInterval] = useState(statisticIntervals[0])

  useEffect(() => {
    dispatch(
      getTutorStats({
        period: interval.toLowerCase(),
        breakdown: statisticBreakdowns[interval],
      })
    )
  }, [dispatch, interval, tab])

  return (
    <div className="max-w-7xl">
      <div className="h-72 w-full flex mb-3">
        <MyWallet containerClassName="w-1/4 mr-2" />
        <NextClass nextClass={nextClass} containerClassName="w-1/4 mr-2" />
        <Classes containerClassName="w-1/4 mr-2" />
        <MyProfileTutor containerClassName="w-1/4" />
      </div>

      <div className="grid grid-cols-3 gap-2">
        <TopTutors topTutors={topTutors} />
        <TopCategories topCategories={topCategories} />
        <News className="max-h-[224px]" />
      </div>

      <StatisticCard
        tab={tab}
        interval={interval}
        onTabChange={setTab}
        onIntervalChange={setInterval}
      />
    </div>
  )
}

export default Statistic
